import { render, staticRenderFns } from "./AppTooltip.vue?vue&type=template&id=68e64da8&scoped=true&"
import script from "./AppTooltip.vue?vue&type=script&lang=js&"
export * from "./AppTooltip.vue?vue&type=script&lang=js&"
import style0 from "./AppTooltip.vue?vue&type=style&index=0&id=68e64da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e64da8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
